<ng-container *ngIf="visible">
    <app-dialog [title]="dialogTitle" [disabled]="true" [template]="detailAlmacen" (accepted)="onDialogAccepted($event)"></app-dialog>

    <ng-template #detailAlmacen>
        <app-codigoconfeccion-edit [dialogMode]="true" [id]="Id" [readonly]="true"></app-codigoconfeccion-edit>
    </ng-template>
</ng-container>

